import _ from 'lodash';
import { createSelector } from 'reselect';

import RefData from 'ref-data';

import Enums from '../../common/enums';
import { CapabilityGate, capabilities } from '../../common/Services';

const _scopedState = (state) => state.entities.account;

const activeAccount = (state) => _scopedState(state).active;

const _relativeAccountsById = (state) => _scopedState(state).relativeAccounts.byId;

const relativeAccounts = createSelector([_relativeAccountsById], (accounts) => _.values(accounts));

const relativeAccountsOrdered = createSelector(
  [relativeAccounts, (state, orderBy) => ({ orderBy })],
  (accounts, { orderBy }) =>
    _.orderBy(accounts, [(account) => account[orderBy].toLowerCase()], Enums.sortDirections.ASCENDING)
);

const accountApiData = (state) => activeAccount(state).apiData || {};

const usesExpressAppSwitcher = createSelector(
  [activeAccount],
  (account) =>
    CapabilityGate(capabilities.CM_DATA_INTEGRATION) &&
    account?.plan === RefData.Enum.PLAN.ACCOUNT_SUBSCRIPTION.EXPRESS_100
);

/**
 * Returns the feature flags for the account
 * they are in shape:
 *  {
 *   "CAPABILITY_NAME":["user@email.com"]
 *  }
 *  where the key is the capability and the value is an array of user emails that can use the feature flag
 */
const accountFeatureFlags = createSelector([activeAccount], (account) => account.featureFlags);

export default {
  activeAccount,

  relativeAccounts,
  relativeAccountsOrdered,
  accountApiData,
  usesExpressAppSwitcher,
  accountFeatureFlags,
};
